var _symbol, _symbol2, _symbol3, _symbol4, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVodafone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 162.98006,
    viewBox: "0 0 17.029376 4.3990977",
    width: 613.571991,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    overflow: "visible"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    overflow: "visible"
  })), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    overflow: "visible"
  })), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    overflow: "visible"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35277779 0 0 .35277779 -15.678062 -255.559219)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    height: "100%",
    width: "100%",
    x: 604.46722,
    xlinkHref: "#a",
    y: 461.6857
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5e5e61",
    height: "100%",
    width: "100%",
    x: 63.516251,
    xlinkHref: "#c",
    y: 72.440201
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5e5e61",
    height: "100%",
    width: "100%",
    x: 87.364098,
    xlinkHref: "#d",
    y: 72.440201
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5e5e61",
    height: "100%",
    width: "100%",
    x: 85.5401,
    xlinkHref: "#d",
    y: 83.4412
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5e5e61",
    height: "100%",
    width: "100%",
    x: 62.882599,
    xlinkHref: "#d",
    y: 94.4422
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5e5e61",
    height: "100%",
    width: "100%",
    x: 63.0023,
    xlinkHref: "#c",
    y: 105.4432
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5e5e61",
    height: "100%",
    width: "100%",
    x: 64.288597,
    xlinkHref: "#d",
    y: 105.4432
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5e5e61",
    height: "100%",
    width: "100%",
    x: 65.020103,
    xlinkHref: "#d",
    y: 116.4442
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5e5e61",
    height: "100%",
    width: "100%",
    x: 44.6217,
    xlinkHref: "#c",
    y: 182.4502
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ee3023",
    height: "100%",
    width: "100%",
    x: 246.70285,
    xlinkHref: "#b",
    y: 61.897499
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5e5e61",
    height: "100%",
    width: "100%",
    x: 308.39111,
    xlinkHref: "#d",
    y: 73.3545
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ee3023",
    height: "100%",
    width: "100%",
    x: 231.27486,
    xlinkHref: "#b",
    y: 101.769
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5e5e61",
    height: "100%",
    width: "100%",
    x: 261.43259,
    xlinkHref: "#d",
    y: 113.226
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ee3023",
    height: "100%",
    width: "100%",
    x: 222.4351,
    xlinkHref: "#b",
    y: 141.6405
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.27560986 0 0 .27560986 -3.5659 -64.77683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.418156 243.01155c0 4.14239-3.356901 7.50067-7.499284 7.50067s-7.500662-3.35828-7.500662-7.50067c0-4.14238 3.358279-7.50066 7.500662-7.50066s7.499284 3.35828 7.499284 7.50066",
    fill: "#ee3023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.978127 247.1939c-2.060167.007-4.204395-1.75149-4.214041-4.57646-.0069-1.86725 1.001834-3.66559 2.288922-4.73219 1.256771-1.03904 2.97794-1.70739 4.53788-1.7129.201194 0 .412034.0165.540191.0606-1.364258.2825-2.450152 1.55305-2.446018 2.99311 0 .0482.0041.0992.0096.12264 2.283409.55673 3.319694 1.93477 3.326585 3.84059.0055 1.90721-1.499306 3.99631-4.043165 4.00458",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ee3023"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.261961 246.11765-2.293056-5.47219h1.497928l1.430403 3.63389 1.386307-3.63389h1.430404l-2.225532 5.47219zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.704745 243.35331c0-.22738-.02617-.44373-.07993-.64906-.05237-.20532-.132291-.38171-.2384-.52916-.106108-.14883-.234267-.26597-.385852-.35278-.151584-.0882-.329349-.13229-.5333-.13229-.203948 0-.383096.0441-.533302.13229-.151581.0868-.281118.20395-.38585.35278-.106109.14745-.186034.32384-.238401.52916-.05374.20533-.07993.42168-.07993.64906 0 .23564.02618.45475.07993.65594.05237.2012.129537.37759.231511.52917.101974.15159.23151.27147.38723.35967.15434.0868.334864.13091.538812.13091.203951 0 .381716-.0441.5333-.13091.151585-.0882.279744-.20808.385852-.35967.106109-.15158.186034-.32797.2384-.52917.05374-.20119.07993-.4203.07993-.65594m1.384929.006c0 .35691-.05512.70693-.163988 1.05144-.110242.34451-.272852.65181-.489204.92466-.214972.27286-.487823.49196-.817174.65871-.329353.16674-.713825.24942-1.152041.24942-.439593 0-.824068-.0827-1.152039-.24942-.329353-.16674-.602202-.38585-.818555-.6587-.214974-.27286-.377583-.58016-.487826-.92467-.108865-.3445-.163987-.69453-.163987-1.05144 0-.35553.05512-.7028.163987-1.04455.110243-.34038.272852-.64492.487826-.91364.216353-.26872.489202-.4837.818555-.6463.327971-.16261.712446-.24529 1.152039-.24529.438216 0 .821312.0827 1.146527.24529.325218.1626.598067.37758.817179.6463.220485.26872.384471.57326.494713.91364.108868.34175.163988.68902.163988 1.04455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.318875 241.84987c-.271473-.10611-.523655-.15985-.757923-.15985-.239778 0-.44786.0469-.620114.1378-.173636.0909-.31695.21359-.429948.36931-.113004.15572-.197062.33073-.253561.52504-.0565.19292-.08544.39274-.08544.59806 0 .22738.02479.44511.07442.65457.04823.20809.124021.39137.225997.54708.100597.15572.228753.28112.383095.37621.15434.0937.337619.14194.54846.14194.173631 0 .350018-.0482.530543-.14194.180523-.0951.308679-.20808.384474-.33624zm.112998 4.26778-.0565-.41892c-.128156.14332-.297656.2701-.509873.37896-.210841.11024-.460264.16536-.746897.16536-.376201 0-.70969-.0799-.994942-.2384-.288012-.15847-.529167-.37069-.72485-.63527-.195678-.26458-.345887-.57189-.447863-.92053-.100594-.34727-.151585-.71107-.151585-1.09003 0-.35553.05237-.70418.157099-1.04455.106109-.34038.265959-.64492.480936-.91364.216352-.26872.485071-.48369.810286-.6463.32384-.16261.705554-.24529 1.142392-.24529.286633 0 .596693.0537.928801.15847v-2.12218h1.406977v7.57232zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.689088 243.55174c-.151585.008-.308681.0221-.468532.04-.159853.0193-.311438.0441-.456131.0744-.305924.0606-.516765.16399-.635275.31144-.117134.14883-.17639.30868-.17639.48369 0 .18052.06615.3266.199814.43684.133672.10886.321085.16398.564999.16398.183279 0 .361042-.0372.531921-.11299.170876-.0758.318325-.17088.439594-.28388zm.112999 2.56178-.05512-.40928c-.15296.16812-.345884.30041-.581527.3955-.235646.0951-.49334.14331-.774462.14331-.235641 0-.463021-.04-.677992-.11988-.217731-.0785-.409279-.19293-.576019-.34038-.166743-.14745-.301792-.32797-.403765-.54433-.103354-.21635-.15434-.46026-.15434-.73311 0-.27147.05236-.51263.159851-.72072.106109-.20808.249423-.38309.432702-.52778.181904-.14332.391364-.26045.62701-.3514.234265-.0909.482312-.15986.740005-.20533.181901-.0372.381715-.0648.59807-.0841.216352-.0193.396875-.0358.541567-.051v-.0799c0-.30317-.07717-.51815-.234264-.64768-.155721-.12816-.370692-.19293-.643546-.19293-.159851 0-.312815.0193-.457507.0579-.144696.0372-.272852.0841-.387229.14056-.114379.0579-.214976.11437-.30317.17088-.08681.0565-.157096.10748-.210838.15296l-.465779-.98668c.06063-.0537.15296-.11713.278362-.19292.125402-.0758.275606-.15021.45475-.22187.177769-.0717.377582-.13229.600827-.1819.223242-.0496.464396-.0744.720711-.0744.303171 0 .580158.04.829583.11989.249423.0799.465775.20395.647674.37482.180525.1695.322463.38448.425817.6463.101973.26045.152961.57602.152961.94671v3.51676zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.435505 239.79384c-.04547-.022-.133667-.0551-.265959-.0965-.13367-.0413-.308679-.062-.529167-.062-.19568 0-.361045.0593-.493337.17639-.132291.11713-.198437.30868-.198437.57326v.26045h1.180978v1.13551h-1.169955v4.33668h-1.408356v-4.33668h-.726223v-1.13551h.726223v-.2949c0-.35553.04548-.65594.136427-.90261.09095-.24529.217731-.44649.380341-.60083.162605-.15572.354153-.27009.573262-.34175.220488-.0717.458888-.10749.716582-.10749.340373 0 .621495.0317.844735.0965.223242.0648.354155.10748.391361.13091zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.273345 243.35331c0-.22738-.02755-.44373-.07993-.64906-.05237-.20532-.132291-.38171-.2384-.52916-.106108-.14883-.23427-.26597-.385852-.35278-.151585-.0882-.329354-.13229-.5333-.13229-.203951 0-.383095.0441-.533302.13229-.151585.0868-.281122.20395-.387231.35278-.104727.14745-.184653.32384-.2384.52916-.05237.20533-.07854.42168-.07854.64906 0 .23564.02617.45475.07854.65594.05375.2012.130916.37759.232891.52917.101974.15159.231511.27147.38585.35967.155716.0868.336241.13091.540192.13091.203946 0 .381715-.0441.5333-.13091.151582-.0882.279744-.20808.385852-.35967.106109-.15158.186034-.32797.2384-.52917.05237-.20119.07993-.4203.07993-.65594m1.384927.006c0 .35691-.05512.70693-.165365 1.05144-.108863.34451-.271473.65181-.487823.92466-.214976.27286-.487825.49196-.817179.65871-.32935.16674-.713822.24942-1.152038.24942-.439597 0-.824068-.0827-1.152043-.24942-.329348-.16674-.602203-.38585-.818552-.6587-.214974-.27286-.377582-.58016-.487826-.92467-.110244-.3445-.163989-.69453-.163989-1.05144 0-.35553.05374-.7028.163989-1.04455.110244-.34038.272852-.64492.487826-.91364.216349-.26872.489204-.4837.818552-.6463.327975-.16261.712446-.24529 1.152043-.24529.438216 0 .821309.0827 1.146527.24529.325215.1626.59807.37758.817176.6463.220485.26872.384474.57326.493337.91364.110244.34175.165365.68902.165365 1.04455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.028032 246.11765v-3.12125c0-.41617-.08682-.73863-.260448-.96601-.175011-.226-.416168-.34037-.727604-.34037-.219107 0-.42168.0565-.606338.17087-.186034.113-.347268.2384-.48369.37483v3.88193h-1.40698v-5.47219h1.282954l.06752.43133c.220488-.18052.467157-.32108.744141-.41892.275606-.0992.553974-.14745.833715-.14745.288007 0 .552591.0427.795126.12953.242536.0882.45062.226.62425.41479.175014.18879.308682.43546.403765.73725.09371.30317.141941.66697.141941 1.09003v3.23563zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.815792 242.72355c-.01516-.1888-.05512-.35416-.119888-.49334-.06477-.14056-.144695-.25356-.239778-.34038-.09509-.0882-.197059-.15158-.307303-.1943-.111623-.0413-.223245-.062-.337622-.062-.243911 0-.475422.0909-.695907.27285-.220485.1819-.350022.45337-.388607.81718zm-2.122177 1.0101c.0303.46164.17363.79513.432704.99907.257694.20396.592556.30731 1.001832.30731.190169 0 .369316-.0179.536056-.051.166743-.0344.315572-.0772.445106-.13091.129538-.0524.239782-.10611.330729-.15848.09095-.0537.158475-.10335.205328-.14882l.374827 1.1479c-.05374.0372-.139181.0882-.256315.15296-.117131.0648-.263202.12403-.436838.1819-.173633.0565-.37896.10474-.613225.14745-.234267.0413-.491961.062-.771702.062-.356912 0-.694531-.0565-1.016992-.1695-.321082-.11437-.603581-.29076-.844741-.52916-.242532-.2384-.435456-.53468-.578773-.89021-.144695-.35554-.216352-.77997-.216352-1.27193 0-.46165.06614-.87092.198437-1.22646.132292-.35553.314193-.65457.544327-.8971.231511-.24116.500227-.42719.806149-.55673.307305-.12815.633899-.19292.982543-.19292s.669727.0579.966005.17087c.294902.113.549835.28939.766191.52779.214971.2384.385849.54708.509873.92604.125402.37759.187412.82821.187412 1.35048v.24943zm0 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodafone);
export default __webpack_public_path__ + "static/media/vodafone.b2eb51027ad8b076de2462900579c6ea.svg";
export { ForwardRef as ReactComponent };